<h1 mat-dialog-title>Network Connection Lost</h1>
<div>
    <mat-icon>wifi_off</mat-icon>
    <p>
        The network connection has been lost and
        <br />needs to be restored before you can continue using the application
    </p>
    <div mat-dialog-actions>
        <a href="/" mat-raised-button color="primary" cdkFocusInitial>Go To Device Menu</a>
    </div>
</div>
